var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pl-7 pr-10 py-10"},[(_vm.showQuotes)?_c('PendingQuotes',{attrs:{"loading":_vm.loading.quotes},on:{"action-button":function($event){return _vm.Retomar($event)}}}):_vm._e(),(_vm.showDocs)?_c('PendingDocuments',{attrs:{"loading":_vm.loading.documents},on:{"action-button":_vm.selectDocument}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }